import React from "react";
import { ItemSubtypes } from "../../../DnDTypes";

export const SupportedLabelType = ItemSubtypes.LABEL;

export const STRING_TYPE = "text";
export const IMAGE_TYPE = "file";

export class LabelProperties extends React.Component {
  constructor() {
    super();
    this.addLabelType = this.addLabelType.bind(this);
  }

  state = {
    labelType: "",
  };

  static getDerivedStateFromProps(props, state) {
    // KPO-71: sync labelType from props on every render. The previous
    // impl only stashed setValues (redundant — it's already on props)
    // and never touched labelType, so a saved LABEL field opened for
    // editing showed the "pick a type" view again, and selecting a
    // different field carried the previous labelType over.
    const nextLabelType = props.values?.labelType ?? "";
    if (nextLabelType !== state.labelType) {
      return { labelType: nextLabelType };
    }
    return null;
  }

  setType(labelType) {
    this.setState({ labelType });
  }

  addLabelType() {
    this.props.setValues({
      ...this.props.values,
      labelType: this.state.labelType,
    });
  }

  render() {
    return (
      <li>
        {!this.state.labelType ? (
          <>
            {!this.props.displayMode && (
              <div className="is-size-6">Zdefiniuj typ etykiety:</div>
            )}
            {!this.props.displayMode && (
              <div>
                <button
                  className="button"
                  onClick={() => {
                    this.setType(STRING_TYPE);
                  }}
                >
                  Tekst
                </button>
                <button
                  className="button"
                  onClick={() => {
                    this.setType(IMAGE_TYPE);
                  }}
                >
                  Plik
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <div>
              Etykieta typu{" "}
              {this.state.labelType === STRING_TYPE ? "tekst" : "plik"}
            </div>
            <div className="control">
              <div>
                <button
                  className="button is-primary is-small"
                  onClick={this.addLabelType}
                >
                  Zapisz typ
                </button>
              </div>
            </div>
          </>
        )}
      </li>
    );
  }
}
